import moment from 'moment';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { FBoxContainer } from '../../../components/base';
import CSNToReviewCard from './CSNToReviewCard';
import CardLoader from './CardLoader';
import { FORTA_BLUE, FORTA_SUCCESS } from '../../../utils/colors';

import type { RootState } from '../../../store';

function ClientSNToReview() {
  const { supervisionMetricsList, loading: metricsLoading } = useSelector(
    (state: RootState) => state.metrics,
  );
  return (
    <FBoxContainer
      sx={{ flexGrow: 0, minHeight: '35vh', textAlign: 'left', height: 450 }}
      contentStyle={{
        pr: supervisionMetricsList?.length > 3 ? 1 : 2,
      }}
    >
      <Typography sx={{ color: FORTA_BLUE.primary, fontSize: 18, fontWeight: 500 }}>
        {`Clients below CSN requirements (${moment().format('MMM-YYYY')})`}
      </Typography>
      <Box sx={{ overflowY: 'auto', height: 355, mt: 2.5 }}>
        {metricsLoading ? (
          Array.from({ length: 3 }).map((_, i) => <CardLoader sx={{ mr: 1 }} key={i} />)
        ) : supervisionMetricsList?.length === 0 ? (
          <Box
            sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <CheckCircleIcon sx={{ color: FORTA_SUCCESS }} />
            <Typography ml={0.5}>You&apos;re all caught up!</Typography>
          </Box>
        ) : (
          supervisionMetricsList.map((metrics) => {
            return (
              <CSNToReviewCard
                key={metrics.client?.id}
                id={metrics.client?.id}
                additional_csn_duration_required={metrics.additional_csn_duration_required}
                clientName={`${metrics?.client.first_name} ${metrics?.client.last_name}`}
                session_duration={metrics.session_duration}
                client_supervision_duration={metrics.client_supervision_duration}
              />
            );
          })
        )}
      </Box>
    </FBoxContainer>
  );
}

export default ClientSNToReview;
